import { render, staticRenderFns } from "./PersonnelAssess.vue?vue&type=template&id=1cccb975&"
import script from "./PersonnelAssess.vue?vue&type=script&lang=js&"
export * from "./PersonnelAssess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports